import { instanceOf } from 'prop-types'

import Settings from '../../../../../models/settings.js'

const CARD_BANNER_KEY = 'bzfy-tilegrid-card-banner'

export default function GridCardBanner(props) {
  const { innerRef, settings } = props
  if (!settings.showBanner) {
    return null
  }

  const bannerTagline = settings.bannerPrimaryText
  const bannerTitle = settings.bannerSecondaryText

  const bannerStyles = {
    backgroundColor: settings.bannerBackgroundColor,
  }

  const bannerTaglineStyles = {
    fontSize: settings.bannerPrimaryFontSize,
    color: settings.bannerPrimaryColor,
  }

  const bannerTitleStyles = {
    fontSize: settings.bannerSecondaryFontSize,
    color: settings.bannerSecondaryColor,
  }

  return (
    <div key={CARD_BANNER_KEY} ref={innerRef} className="bzfy-c-tilegrid-post-container">
      <div className="bzfy-c-tilegrid-post-container__inner" style={bannerStyles}>
        <div className="bzfy-c-tilegrid-plain-post-container">
          <div className="bzfy-c-tilegrid-plain-post">
            <div className="bzfy-c-tilegrid-plain-post__inner-wrap">
              <div className="bzfy-c-tilegrid-plain-post__content">
                <div className="bzfy-feed-card-banner__tagline" style={bannerTaglineStyles}>
                  {bannerTagline}
                </div>
                <div style={bannerTitleStyles}>{bannerTitle}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

GridCardBanner.propTypes = {
  innerRef: instanceOf(Function).isRequired,
  settings: instanceOf(Settings).isRequired,
}
